import dayjs from 'dayjs';
import filter from 'lodash/filter';
import CardValidator from 'card-validator';
import customParseFormat from 'dayjs/plugin/customParseFormat';

import { StoredCard } from '@/views/checkout/components/payment-methods/payment-card/interfaces';
import { CardTypeConfig } from '../interfaces/card-type-config';

dayjs.extend(customParseFormat);

export function getCardType(number?: string) {
    if (!number || number === '') {
        return '';
    }

    return CardValidator.number(number)?.card?.type || '';
}

export function getCardTypeName(number: string) {
    if (!number || number === '') {
        return '';
    }

    return CardValidator.number(number)?.card?.niceType || '';
}

export function isExpired(month: string, year: string) {
    if (!month || !year || year.length <= 1) {
        return true;
    }

    return dayjs(`${month}-${year}`, ['M-YYYY', 'M-YY', 'MM-YYYY', 'MM-YY'])
        .endOf('month')
        .isBefore(Date.now());
}

export function isStoredCardExpired(card: StoredCard) {
    return isExpired(card.expirationMonth, card.expirationYear);
}

export function getFormattedDate(month: string, year: string) {
    return dayjs(`${month}-${year}`, ['M-YYYY', 'M-YY', 'MM-YYYY', 'MM-YY']).format('MM/YY');
}

export function getCardMonthYear(date?: string) {
    if (!date || !date.trim().length) {
        return {
            month: '',
            year: ''
        };
    }

    const expirationDate = date.split('/');

    return {
        month: expirationDate[0]?.trim() ?? '',
        year: expirationDate[1]?.trim() ?? ''
    };
}

export function maskCardNumber(
    cardNumber: string,
    maskChar: string = 'X',
    prefix: number = 6,
    suffix: number = 4
) {
    return [
        cardNumber.substring(0, prefix),
        maskChar.repeat(cardNumber.length - prefix - suffix),
        cardNumber.substring(cardNumber.length - suffix)
    ].join('');
}

export function excludePatternsFromCardType(cardType: string, excludedPatterns: number[]) {
    const cardTypeInfo: CardTypeConfig = CardValidator.creditCardType.getTypeInfo(cardType);

    return {
        ...cardTypeInfo,
        patterns: filter(cardTypeInfo.patterns,
            (value) => typeof value === 'number' && !excludedPatterns.includes(value))
    };
}
